<mat-form-field appearance="outline" class="w-100" (click)="validateField()">
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="control">
    <mat-option [value]="true">Sim</mat-option>
    <mat-option [value]="false">Não</mat-option>
  </mat-select>
  <mat-error *ngIf="control.hasError('required')">Campo obrigatório</mat-error>
</mat-form-field>
